import { useCallback } from 'react';

import { useManageSearchParams } from './useManageSearchParams';

import { CLEAR_API_PREVIEW_ID } from '../constants/bot';
import { CHAT_SEARCH_PARAM_KEY } from '../pages/BotsPage/BotDetailPage/BotPreviewPanel/BotPreviewPanel';

export const useClearCustomBotPreview = () => {
    const { deleteSearchParam } = useManageSearchParams();

    const clearAssistantPreview = useCallback(
        () => deleteSearchParam(CHAT_SEARCH_PARAM_KEY),
        [deleteSearchParam]
    );

    const clearApiPreview = useCallback(() => {
        const button = document.getElementById(CLEAR_API_PREVIEW_ID);
        if (button) {
            button.click();
        }
    }, []);

    const clearBotPreview = useCallback(() => {
        clearApiPreview();
        clearAssistantPreview();
    }, [clearApiPreview, clearAssistantPreview]);

    return { clearAssistantPreview, clearApiPreview, clearBotPreview };
};
